import { ReactElement } from 'react'

import { Text, TextProps } from '../../../Text'
import { NavItemVariant } from '../../types/navItemVariant'
import { getStateToStyles } from '../../utils/getStateToStyles'

interface NavListItemTextProps extends Omit<TextProps, 'variant'> {
  variant?: NavItemVariant
}

export const NavListItemText = ({
  color,
  children,
  variant = 'primary',
  ...rest
}: NavListItemTextProps): ReactElement => {
  const { textColor } = getStateToStyles()[variant].default

  return (
    <Text color={color || textColor} weight="medium" truncate {...rest} selectable={false}>
      {children}
    </Text>
  )
}
